<script setup lang="ts">
const isFeatureEnabled = useFeatureFlag()
</script>

<template>
  <div v-if="isFeatureEnabled" class="z-40 flex gap-2">
    <slot />
    <span class="mt-1 size-2 rounded-full bg-yellow-500" />
  </div>
</template>
